<template>
  <Form :method="method" :action="action" :form-data="form" @success="success">
    <template v-slot="{ errors, submitting }">
      <div class="sm:flex sm:-mx-3">
        <div class="sm:flex-1 sm:mx-3" v-if="hide != 'details'">
          <div class="mb-3 mt-1">Vul hier je factuuradres in</div>
          <label class="block mb-3">
            <span class="block mb-1">Bedrijfsnaam</span>
            <BaseInput
              v-model="form.name"
              :error="errors.name"
              name="name"
              class="w-full"
              required
              v-focus
            />
          </label>
          <label class="block mb-3">
            <span class="block mb-1 flex items-baseline">Adres</span>
            <BaseInput
              v-model="form.address_line_1"
              :error="errors.address_line_1"
              name="address_line_1"
              class="w-full"
              required
            />
          </label>
          <label class="block mb-3">
            <span class="block mb-1">Postcode en plaats</span>
            <BaseInput
              v-model="form.address_line_2"
              :error="errors.address_line_2"
              name="address_line_2"
              class="w-full"
              required
            />
          </label>
        </div>
        <div class="sm:flex-1 sm:mx-3" v-if="hide != 'licenses'">
          <div class="mb-3 mt-1">Met hoeveel gebruikers wil je in het pakket gebruiken?</div>
          <label class="block mb-3">
            <span class="block mb-1">Aantal licenties (gebruikers)</span>
            <BaseInput
              v-model="form.licenses"
              :error="errors.licenses"
              name="licenses"
              class="w-full"
              type="number"
              :min="minLicenses"
              max="25"
              required
            />
          </label>
          <div class="mb-3">
            <span class="block mb-1">Maandbedrag</span>
            <div class="py-2">
              {{ form.licenses }} x {{ licenseFee | formatMoney }} =
              <strong>{{ totalFee | formatMoney }}</strong> (ex. BTW)
            </div>
          </div>
        </div>
      </div>
      <div class="my-2 py-2 px-4 rounded bg-blue-100 text-blue-900 flex" v-if="showStartComment">
        <div class="mt-1 mr-2">
          <BaseIcon name="alert-circle" size="16" />
        </div>
        <div>
          In het scherm dat volgt betaal je eenmalig
          <strong>{{ 0.01 | formatMoney }}</strong> met iDeal.
          Je geeft Smallbee hiermee toestemming om maandelijks de kosten voor het abonnement te incasseren.
        </div>
      </div>
      <div class="flex py-2">
        <BaseButton class="btn btn-blue" :submitting="submitting">{{ buttonText }}</BaseButton>
        <button type="button" class="cancel" @click="close">Annuleren</button>
      </div>
    </template>
  </Form>
</template>

<script>
import Form from "@/components/Form";

export default {
  inject: ["close"],

  props: {
    method: {
      type: String,
      default: "post"
    },
    action: {
      type: String,
      required: true
    },
    subscription: {
      type: Object
    },
    showStartComment: {
      type: Boolean
    },
    buttonText: {
      type: String,
      default: "Opslaan"
    },
    hide: {
      enum: ["details", "licences"]
    }
  },

  components: {
    Form
  },

  data() {
    return {
      form: {
        licenses: this.$store.state.settings.users.length,
        name: "",
        address_line_1: "",
        address_line_2: ""
      },
      licenseFee: 10 // Magic number alert!
    };
  },

  computed: {
    totalFee() {
      let licenses = this.form.licenses;
      if (licenses < this.minLicenses) licenses = this.minLicenses;
      return licenses * this.licenseFee;
    },

    minLicenses() {
      return this.$store.state.settings.users.length;
    }
  },

  created() {
    if (this.subscription) {
      this.form.licenses = this.subscription.licenses;
      this.form.name = this.subscription.name;
      this.form.address_line_1 = this.subscription.address_line_1;
      this.form.address_line_2 = this.subscription.address_line_2;
    }
  },

  methods: {
    success(data) {
      this.close();
      if (data.checkout_url) {
        this.$emit("redirect", data.checkout_url);
      } else {
        this.$emit("success", data);
      }
    }
  }
};
</script>
